module.exports = __webpack_public_path__ + "img/logo.cfe9c501.svg";